import { useCallback, useEffect, useRef, useState } from 'react';

/** Flips true on `flash()`, auto-resets to false after `durationMs`. */
export const useFlashFlag = (durationMs = 2000): {
  flashed: boolean;
  flash: () => void;
} => {
  const [flashed, setFlashed] = useState(false);
  const timerRef = useRef<ReturnType<typeof setTimeout>>(undefined);

  useEffect(() => () => {
    if (timerRef.current) clearTimeout(timerRef.current);
  }, []);

  const flash = useCallback(() => {
    setFlashed(true);
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => setFlashed(false), durationMs);
  }, [durationMs]);

  return { flashed, flash };
};
